import { VatDeclarationPeriod } from "./period";

export class VatDeclarationData {
	Period:VatDeclarationPeriod | null= null;
	Grid61:number = 0.0;
	Grid62:number = 0.0;
	Grid57:number = 0.0;
	Grid91:number = 0.0;
	RequestRefund:boolean = false;
	RequestPaymentForms:boolean = false;
	NihilListing:boolean = false;

	public getJSON(){
		if (!this.Period) throw new Error("Missing period");
		return {
			Period: this.Period.getJSON(),
			Grid61: this.Grid61,
			Grid62: this.Grid62,
			Grid57: this.Grid57,
			Grid91: this.Grid91,
			RequestRefund: this.RequestRefund,
			RequestPaymentForms: this.RequestPaymentForms,
			NihilListing: this.NihilListing
		};
	}
}